<section [formGroup]="formGroup">
  <h6 class="fs-5">
    {{ 'report_type_configuration' | translation }}
  </h6>
  <mat-form-field appearance="fill" class="w-100">
    <mat-label>
      {{ 'report_type_configuration' | translation }}
    </mat-label>
    <mat-select formControlName="configuration" (selectionChange)="onConfigurationTypeChange()">
      <mat-option [value]="'irrigationCosts'">
        {{ 'reports_irrigation_costs' | translation }}
      </mat-option>
      <mat-option [value]="'fertilizationCosts'">
        {{ 'reports_fertilization_costs' | translation }}
      </mat-option>
      <mat-option [value]="'waterSources'">
        {{ 'reports_water_sources' | translation }}
      </mat-option>
      <mat-option [value]="'terminal'">
        {{ 'terminal_terminal' | translation }}
      </mat-option>
    </mat-select>
  </mat-form-field>
</section>
